window.onload = function(){
    
    if(!(document.body.scrollHeight > (window.innerHeight || document.documentElement.clientHeight))){
        var footer = document.querySelector(".footer");
        footer.style.position = "absolute";
        footer.style.margin = "auto";
    }
}


// WEBPACK FOOTER //
// ./src/js/download.js